import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { Corner } from '@material/menu-surface';
import $ from 'jquery';
import { MDCMenu } from '@material/menu';
import 'next/stylesheets/components/projects/todo-combo-filter';

Component('tr-todo-normal-project-filter', {
  mixins: [eventListenerMixin],

  properties: {
    filtered: {
      type: Boolean,
      default: false,
    },

    filterUrl: {
      type: String,
    },
    filterCategory: {
      type: String,
    },
  },

  connected() {
    this.menu = new MDCMenu(this.querySelector('.mdc-menu'));

    this.triggerButton = this.querySelector('.filter-toggle-button');
    this.listenTo(this.triggerButton, 'click', this.toggleFilterForm.bind(this));

    this.listenTo(this.menu, 'MDCMenu:selected', this.handleSelected.bind(this));
  },

  ready() {
    this.menu.setAnchorElement(this.triggerButton);
    this.menu.setAnchorCorner(Corner.BOTTOM_LEFT);
  },


  toggleFilterForm() {
    this.menu.open = !this.menu.open;
  },

  handleSelected(event) {
    let { key, value } = event.detail.item.dataset;

    if (!key || key === 'advance') {
      return;
    }

    let predicate = 'eq';

    if (key === 'assignee_id') {
      value = ['', value];
      predicate = 'in';
    } else if (key === 'overdue') {
      key = 'due_at';
      value = 'this_day';
      predicate = 'lt';
    }

    const data = {
      projects_filter: {
        category: this.filterCategory,
        conditions_attributes: {
          0: {
            key,
            predicate,
            conjunction: 'con_and',
            form_value: value,
          },
        },
      },
    };

    $.post(this.filterUrl, data, () => {}, 'script');
  },

  disconnected() {
    this.stopListening();
  },
});
